import './index.scss'
$("header .nav li").eq(4).addClass("active");
$(".subnav ul").eq(3).addClass("on");
let h2_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.news-list li h2').each(function() { //遍历相同样式名的元素
    let h2 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    h2_max = h2 > h2_max ? h2 : h2_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.news-list li h2').height(h2_max); //给每一个元素设置相同的高度	

let p_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.news-list li p').each(function() { //遍历相同样式名的元素
    let p = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p_max = p > p_max ? p : p_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.news-list li p').height(p_max); //给每一个元素设置相同的高度	